import { makeRequest } from 'features/entry-form-v2/data/makeRequest';

export const confirmFileUploadForSurvey = async ({
	surveyId,
	pinCode,
	fileId
}: {
	surveyId: string;
	pinCode: string;
	fileId: string;
}) => {
	return makeRequest({
		method: 'confirmFileUploadForSurvey',
		service: 'cde',
		validateCredentials: false,
		data: {
			surveyId,
			pinCode,
			fileId
		}
	});
};
